import { Component, Inject } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';


/**
 * Component for displaying alerts.
 */
@Component({
  selector: 'app-alert',
  imports: [MatIcon],
  templateUrl: './alert.html',
  styleUrl: './alert.scss',
})
export class AlertComponent {
  /**
   * Initializes the component.
   * @param data The data injected into the snackbar, containing the alert message and type.
   */
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
